import "./Community.css";
import "./CommunityResponsive.css";

import Banner from "../../../shared/banner/Banner";
import Tabs from "../../../widgets/tabs/Tabs";
import communityProgramsData from "../../../assets/data/community-programs/communityPrograms.json";
import community from "../../../assets/images/community/community-5.jpg";
import { useLoadCommunityImages } from "../../../hooks/useLoadCommunityImages";
import ImageRender from "../../../widgets/image-render/ImageRender";
import CustomAnchor from "../../../shared/Anchor/CustomAnchor";
import Accordion from "../../../widgets/accordion/Accordion";

function Community() {
  const communityImages = useLoadCommunityImages();
  return (
    <>
      <Banner>
        <span>ABOUT US</span>
        <span>/</span>
        <span>COMMUNITY PROGRAMS</span>
      </Banner>

      <div className="row m-0 community-programs-overview">
        <div className="col-12">
          <h2>GROWING HEALTHIER COMMUNITIES, ONE GARDEN AT A TIME</h2>
        </div>
        <div className="col-sm-6 col-12">
          <img
            src={community}
            alt="Farm Overview"
            className="rounded"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
        <div className="col-sm-6 col-12">
          <div className="about-us-content-wrapper">
            <div className="d-block">
              <div className="about-header-border"></div>
              <p>
                At <strong>Standout Fresh Produce</strong>, we believe access to
                fresh, nutritious food is a right—not a luxury. Through our
                Community Programs, we empower families, schools, and local
                organizations with tools, knowledge, and support to eat better,
                live healthier, and farm smarter. Whether it's teaching kids to
                grow spinach or helping seniors prepare wholesome meals, our
                programs create long-lasting impact rooted in health,
                sustainability, and connection.
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="row m-0 community-program-slide">
        {Object.entries(communityImages)
          ?.filter(([key, _]) => !key.includes("community"))
          .map(([key, value]) => {
            return (
              <div className="community-program-image col-md-3 col-sm-6 col-11">
                <ImageRender
                  classname="community-program"
                  path={value}
                  key={key}
                />
              </div>
            );
          })}
      </div>
      <hr />
      <div className="product-service-title">
        <h1>
          <span className="product-service-title-products">
            OUR COMMUNITY PROGRAMS
          </span>
        </h1>
      </div>
      {/* <Tabs data={communityProgramsData} /> */}
      <div className="standout-products-services-tabs">
        <Tabs data={communityProgramsData} />
      </div>
      <div className="standout-products-services-accordion">
        <Accordion data={communityProgramsData} />
      </div>
      <div className="community-previous-event-container">
        <div className="community-program-previous-events">
          <h1>PREVIOUS PROGRAM EVENTS</h1>
        </div>
        <div className="community-previous-event-wrapper">
          <div className="row m-0">
            <div className="col-sm-6 col-12">
              <CustomAnchor
                path="/about/community/2025"
                classname="btn btn-link p-0 community-previous-event-cover"
              >
                <div className="community-previous-event-cover">
                  <div className="community-previous-event-overlay">
                    <span>2025</span>
                  </div>
                  <img
                    src={community}
                    alt="Community previous event cover"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
              </CustomAnchor>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Community;
